import React, { useContext, useMemo } from 'react';

import { Button, IconButton } from '@material-ui/core';
import { DropdownIcon } from 'components/Icons';

import useStyle from './style';

import MensagensContext from 'pages/Assessor/MensagensAssessor/Context';

export default function Paginacao() {
  const classes = useStyle();
  const { paginaAtual, irParaPagina, conversas } = useContext(MensagensContext);

  const pages = useMemo(() => {
    const arr = [];
    let count = 0;
    while (arr.length < conversas.totalPages) {
      count += 1;
      arr.push(count);
    }
    return arr.filter((page) => {
      const tenth = paginaAtual + 10;
      if (tenth > conversas.totalPages) {
        return page >= conversas.totalPages - 9;
      }
      return page >= paginaAtual && page < paginaAtual + 10;
    });
  }, [conversas, paginaAtual]);

  return (
    <nav className={classes.paginacao}>
      {conversas.totalPages > 0 && paginaAtual > 1 && (
        <IconButton
          onClick={() => irParaPagina(paginaAtual - 1)}
          color='primary'
        >
          <DropdownIcon className={classes.paginacaoPrev} />
        </IconButton>
      )}
      {pages[0] > 1 && <span>...</span>}
      {pages.map((page) => (
        <Button
          variant='text'
          key={page}
          onClick={() => irParaPagina(page)}
          disabled={paginaAtual === page}
          color='primary'
          className={classes.paginacaoNumber}
        >
          {page}
        </Button>
      ))}
      {pages[pages.length - 1] < conversas.totalPages && <span>...</span>}
      {paginaAtual < conversas.totalPages && (
        <IconButton
          onClick={() => irParaPagina(paginaAtual + 1)}
          color='primary'
        >
          <DropdownIcon className={classes.paginacaoNext} />
        </IconButton>
      )}
    </nav>
  );
}
